// extracted by mini-css-extract-plugin
export default {"formAdd":"expense_formAdd__GSBv9","formTitle":"expense_formTitle__UDj7F","loginForm":"expense_loginForm__t4eit","loginBack":"expense_loginBack__2ToSn"};